/**
* 打字机效果文本组件
* 用于实现文字逐字显示的动画效果
*
* @component TypewriterText
* @props {String} text - 要显示的文本内容
* @props {Number} speed - 打字速度(毫秒)
*/

<template>
  <div class="typewriter-container">
    <div v-for="(sentence, index) in sentences" :key="index" class="sentence-item">
      <div class="typewriter-text" v-html="sentence.displayText"></div>
      <div v-if="currentStep!=3 && !isView" class="typewriter-button" @click="() => handleModify(index, sentence.text)">智能修改</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue'
import {eventBus} from "@/utils/mitt";

const props = defineProps({
  currentStep: {
    type: Number,
    default: 0
  },
  activeTab:{
    type: Number,
    default: 1
  },
  text: {
    type: String,
    required: true
  },
  speed: {
    type: Number,
    default: 50
  },
  isView: {
    type: Boolean,
    default: false
  }
})

const sentences = ref([])
let timers = []

// 将文本按句子分割
const splitTextIntoSentences = (text) => {
  if (!text) return []
  console.log(text,"text------")
  const splitRegex = /(?=\b\d+\.(?!\d))/;
  const splitArr = text.split(splitRegex);
  const sentenceArray = splitArr.map(item => {
        return item.replace(/\n/g, '').trim();
      }).filter(item => {
        return item !== '' && item !== '.';
      });
  console.log(sentenceArray,"sentenceArray")
  const result = sentenceArray.map(item=>{
    return {
      text: item.trim(),
      displayText: '',
      currentIndex: 0,
      isTyping: false
    }
  })
  console.log(result,"result")
  return result
}

const typeTextForSentence = (sentenceIndex) => {
  const sentence = sentences.value[sentenceIndex]
  if (!sentence || sentence.currentIndex >= sentence.text.length) {
    sentence.isTyping = false
    // 开始下一个句子的打字效果
    if (sentenceIndex + 1 < sentences.value.length) {
      setTimeout(() => {
        startTypingForSentence(sentenceIndex + 1)
      }, 300) // 句子间隔300ms
    }
    return
  }

  // 获取当前字符
  const currentChar = sentence.text[sentence.currentIndex]

  // 如果是换行符，转换为<br>标签
  if (currentChar === '\n') {
    sentence.displayText += '<br>'
  } else {
    sentence.displayText += currentChar
  }

  sentence.currentIndex++
  timers[sentenceIndex] = setTimeout(() => typeTextForSentence(sentenceIndex), props.speed)
}

const startTypingForSentence = (sentenceIndex) => {
  if (sentenceIndex >= sentences.value.length) return
  sentences.value[sentenceIndex].isTyping = true
  typeTextForSentence(sentenceIndex)
}

const resetAndStartTyping = () => {
  // 清除所有定时器
  timers.forEach(timer => clearTimeout(timer))
  timers = []

  // 重新分割句子
  sentences.value = splitTextIntoSentences(props.text)
  console.log(sentences.value,"重新分割句子")
  if (props.isView) {
    // 查看模式，直接显示所有文本
    sentences.value.forEach(sentence => {
      sentence.displayText = sentence.text.replace(/\n/g, '<br>')
    })
  } else {
    // 重置所有句子的显示状态
    sentences.value.forEach(sentence => {
      sentence.displayText = ''
      sentence.currentIndex = 0
      sentence.isTyping = false
    })

    // 开始第一个句子的打字效果
    if (sentences.value.length > 0) {
      startTypingForSentence(0)
    }
  }
}

const handleModify = (sentenceIndex, sentenceText) => {
  console.log(`修改第${sentenceIndex + 1}个句子:`, JSON.stringify(sentenceText))
  console.log(props.activeTab,'444444')

  // 定义字段映射配置
  const fieldMapping = {
    0: { // activeTab = 0 时的句子索引到字段的映射
      1: 'background',
      2: 'technical',
      3: 'effect'
    },
    1: { // activeTab = 1 时统一映射到 background
      default: 'background'
    },
    2: { // activeTab = 2 时统一映射到 technical
      default: 'technical'
    },
    3: { // activeTab = 3 时统一映射到 effect
      default: 'effect'
    }
  }

  // 获取当前 tab 的配置
  const currentTabConfig = fieldMapping[props.activeTab]
  if (!currentTabConfig) {
    console.warn(`未知的 activeTab 值: ${props.activeTab}`)
    return
  }

  // 确定目标字段
  let targetField
  if (props.activeTab === 0) {
    // activeTab = 0 时根据句子索引映射
    targetField = currentTabConfig[sentenceIndex + 1]
    if (!targetField) {
      console.warn(`activeTab=0 时，句子索引 ${sentenceIndex + 1} 没有对应的字段映射`)
      return
    }
  } else {
    // 其他 activeTab 使用默认字段
    targetField = currentTabConfig.default
  }

  // 发送事件
  const eventData = {
    field: targetField,
    sentenceText: sentenceText
  }

  eventBus.emit("aiModify", eventData)
}

watch(() => props.text, () => {
  resetAndStartTyping()
}, { deep: true })

onMounted(() => {
  resetAndStartTyping()
})
</script>

<style scoped>
.typewriter-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sentence-item {
  border: 2px solid #00A160;
  border-radius: 8px;
  padding: 16px;
  background: #f8fdff;
  position: relative;
}

.typewriter-text {
  white-space: pre-wrap;
  line-height: 1.8;
  margin-bottom: 12px;
  color: #333;
}

.typewriter-button {
  position: absolute;
  bottom: 8px;
  right: 8px;
  background: #00A160;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.typewriter-button:hover {
  background: #1ea160;
  transform: translateY(-1px);
}

:deep(br) {
  display: block;
  content: "";
  margin: 0.5em 0;
}
</style>
